import React from 'react'
import PropTypes from 'prop-types'

const Loader = ({ className, message }) => {
  return <>
    <div data-testid='loader' className={`${['Loader--container', className].filter(Boolean).join(' ')}`}>
      <svg className='Loader' width='60' height='60' aria-labelledby='content-loading' role='img'>
        <title id='content-loading'>Loader</title>
        <circle cx='30' cy='30' r='28' fill='none' />
      </svg>
      <br />
      {message && <p className='Loader--message'>{message}...</p>}
    </div>
  </>
}

Loader.propTypes = {
  /** A loader can have additional CSS class applied to it */
  className: PropTypes.string,
  /** A loader can display helpful text below the loading spinner */
  message: PropTypes.string
}

export default Loader